// extracted by mini-css-extract-plugin
export default {"root":"_2o-Ze","cover":"_5F1x4","middle":"v9XYd","mature-block":"tqigF","matureBlock":"tqigF","underlay":"_3RUpU"};